/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { commonReducers, CommonState } from '../_common/commonReducers';

export interface ResultPicture {
 Id: number;
 PicWhen: string;
 KescId: number;
 UserName: string;
 Weighings: {
  Id: number;
  Time: string;
  Weight: number;
 };
 PicData: string;
 Type: string;
}

interface ResultsState extends CommonState {
 // Additional results-specific properties can be added here
 pictures: ResultPicture[];
}

const initialState: ResultsState = {
 items: [],
 aggregate: null,
 item: null,
 structure: [],
 documents: [],
 rowCount: '0',
 loading: {},
 success: {},
 pictures: [],
 excel: null,
};

const resultsSlice = createSlice({
 name: 'results',
 initialState,
 reducers: {
  ...commonReducers,
  approveResultStart(state, action: PayloadAction<any>) {
   return {
    ...state,
    loading: { ...state.loading, approveResult: true },
   };
  },
  approveResultSuccess(state, action: PayloadAction<any>) {
   return {
    ...state,
    success: { ...state.success, approveResult: true },
    loading: { ...state.loading, approveResult: null },
   };
  },
  approveResultFailure(state, action: PayloadAction<any>) {
   return {
    ...state,
    success: { ...state.success, approveResult: false },
    loading: { ...state.loading, approveResult: null },
   };
  },
  approveResultFinish(state) {
   return {
    ...state,
    success: { ...state.success, approveResult: null },
    loading: { ...state.loading, approveResult: null },
   };
  },
  getResultPicturesStart(state, action: PayloadAction<any>) {
   return {
    ...state,
    loading: { ...state.loading, getResultPictures: true },
   };
  },
  getResultPicturesSuccess(state, action: PayloadAction<any>) {
   return {
    ...state,
    pictures: action.payload,
    success: { ...state.success, getResultPictures: true },
    loading: { ...state.loading, getResultPictures: null },
   };
  },
  getResultPicturesFailure(state, action: PayloadAction<any>) {
   return {
    ...state,
    success: { ...state.success, getResultPictures: false },
    loading: { ...state.loading, getResultPictures: null },
   };
  },
  getResultPicturesFinish(state) {
   return {
    ...state,
    success: { ...state.success, getResultPictures: null },
    loading: { ...state.loading, getResultPictures: null },
   };
  },
 },
});

export const {
 getTableStart,
 getTableSuccess,
 getTableFailure,
 getTableFinish,

 getItemStart,
 getItemSuccess,
 getItemFailure,

 createItemStart,
 createItemSuccess,
 createItemFailure,
 createItemFinish,

 updateItemStart,
 updateItemSuccess,
 updateItemFailure,
 updateItemFinish,

 deleteItemStart,
 deleteItemSuccess,
 deleteItemFailure,
 deleteItemFinish,

 getTableStructureStart,
 getTableStructureSuccess,
 getTableStructureFailure,

 getItemDocumentsStart,
 getItemDocumentsSuccess,
 getItemDocumentsFailure,

 uploadItemDocumentsStart,
 uploadItemDocumentsSuccess,
 uploadItemDocumentsFailure,
 uploadItemDocumentsFinish,

 deleteItemDocumentStart,
 deleteItemDocumentSuccess,
 deleteItemDocumentFailure,
 deleteItemDocumentFinish,

 getTableExcelStart,
 getTableExcelSuccess,
 getTableExcelFailure,
 getTableExcelFinish,

 approveResultStart,
 approveResultSuccess,
 approveResultFailure,
 approveResultFinish,

 getResultPicturesStart,
 getResultPicturesSuccess,
 getResultPicturesFailure,
 getResultPicturesFinish,
} = resultsSlice.actions;

export default resultsSlice;
